//export const API_HOST = window.location.host.startsWith("localhost")
//  ? "https://app.platformed.build:8080/external_api"
//  : "https://app.platformed.com/external_api";

export const API_HOST = "https://app.platformed.com/external_api";
